export default __webpack_public_path__ + "static/media/heart.b68132c9.svg";